import { render, staticRenderFns } from "./payresult.vue?vue&type=template&id=d2bef23e&scoped=true&"
import script from "./payresult.vue?vue&type=script&lang=js&"
export * from "./payresult.vue?vue&type=script&lang=js&"
import style0 from "./payresult.vue?vue&type=style&index=0&id=d2bef23e&prod&lang=less&scoped=true&"
import style1 from "./payresult.vue?vue&type=style&index=1&id=d2bef23e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bef23e",
  null
  
)

export default component.exports